import React, { useState } from 'react';

interface ValidityPeriodInputProps {
  value?: string;
  onChange: (id: number, value: string) => void;
  isReadOnly?: boolean;
  isChatPage?: boolean;
  isPharmacyModal?: boolean;
  onUserValidityInputChange?: (input: string) => void;
  userValidityInput?: string;
  styles?: React.CSSProperties;
  containerStyles?: React.CSSProperties;
  showCheckbox?: boolean;
  onCheckboxChange?: (checked: boolean) => void;
  isCheckboxChecked?: boolean;
  
  showPeriodCheckboxes?: boolean;
  onPeriodChange?: (period: '30' | '60' | '1year') => void;
  periodCheckboxStates?: {
    [17]: boolean; // 30 дней
    [18]: boolean; // 60 дней  
    [19]: boolean; // 1 год
  };
  showInputField?: boolean;
}

const ValidityPeriodInput: React.FC<ValidityPeriodInputProps> = ({
  value = '',
  onChange,
  isReadOnly = false,
  isChatPage = false,
  isPharmacyModal = false,
  onUserValidityInputChange,
  userValidityInput,
  styles = {},
  containerStyles = {},
  showCheckbox = false,
  onCheckboxChange,
  isCheckboxChecked = false,
  showPeriodCheckboxes = false,
  onPeriodChange,
  periodCheckboxStates = { 17: false, 18: false, 19: false },
  showInputField = true
}) => {
  const [chatValidityPeriod, setChatValidityPeriod] = useState('');

  const handleValidityPeriodChange = (inputValue: string) => {
    const val = inputValue.replace(/\D/g, '').slice(0, 3);
    
    if (isChatPage) {
      setChatValidityPeriod(val);
    }
    
    onChange(99, val);
    onUserValidityInputChange?.(val);
  };

  const defaultInputStyles: React.CSSProperties = {
    width: '40px',
    border: 'none',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontSize: '12pt',
    height: '20px',
    ...styles
  };

  const defaultContainerStyles: React.CSSProperties = {
    textAlign: 'left',
    fontSize: '12pt',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    ...containerStyles
  };

  return (
    <div style={defaultContainerStyles}>
      {!showPeriodCheckboxes && showInputField && (
        <>
          <span>Срок действия рецепта</span>
          <input
            type="text"
            style={defaultInputStyles}
            value={isChatPage ? chatValidityPeriod : (userValidityInput || value)}
            onChange={e => handleValidityPeriodChange(e.target.value)}
            disabled={isPharmacyModal ? true : (isChatPage ? false : isReadOnly)}
            maxLength={3}
            inputMode="numeric"
            pattern="\d*"
          />
          <span>дней</span>
          {/* {showCheckbox && (
            <input
              type="checkbox"
              checked={isCheckboxChecked}
              onChange={() => onCheckboxChange?.(!isCheckboxChecked)}
            />
          )} */}
        </>
      )}
      
      {showPeriodCheckboxes && (
        <>
          <p style={{ fontSize: '10pt', fontWeight: 'bold', alignSelf: 'center' }}>Рецепт действителен:</p>
          
          <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {showCheckbox && (
                <input
                  type="checkbox"
                  checked={periodCheckboxStates[17] || false}
                  onChange={() => onPeriodChange?.('30')}
                />
              )}
              <span 
                style={{ 
                  textDecoration: periodCheckboxStates[17] ? 'underline' : 'none',
                  textDecorationThickness: '2px',
                  textDecorationColor: '#000',
                  textUnderlineOffset: '2px',
                  cursor: isReadOnly ? 'default' : 'pointer',
                  fontSize: '10pt',
                  fontWeight: 'bold'
                }}
                onClick={() => !isReadOnly && onPeriodChange?.('30')}
              >
                30 дней
              </span>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {showCheckbox && (
                <input
                  type="checkbox"
                  checked={periodCheckboxStates[18] || false}
                  onChange={() => onPeriodChange?.('60')}
                />
              )}
              <span 
                style={{ 
                  textDecoration: periodCheckboxStates[18] ? 'underline' : 'none',
                  textDecorationThickness: '2px',
                  textDecorationColor: '#000',
                  textUnderlineOffset: '2px',
                  cursor: isReadOnly ? 'default' : 'pointer',
                  fontSize: '10pt',
                  fontWeight: 'bold'
                }}
                onClick={() => !isReadOnly && onPeriodChange?.('60')}
              >
                60 дней
              </span>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {showCheckbox && (
                <input
                  type="checkbox"
                  checked={periodCheckboxStates[19] || false}
                  onChange={() => onPeriodChange?.('1year')}
                />
              )}
              <span 
                style={{ 
                  textDecoration: periodCheckboxStates[19] ? 'underline' : 'none',
                  textDecorationThickness: '2px',
                  textDecorationColor: '#000',
                  textUnderlineOffset: '2px',
                  cursor: isReadOnly ? 'default' : 'pointer',
                  fontSize: '10pt',
                  fontWeight: 'bold'
                }}
                onClick={() => !isReadOnly && onPeriodChange?.('1year')}
              >
                1 год
              </span>
            </div>
          </div>
          
          {showInputField && (
            <>
              <span>или</span>
              <input
                type="text"
                style={defaultInputStyles}
                value={isChatPage ? chatValidityPeriod : (userValidityInput || value)}
                onChange={e => handleValidityPeriodChange(e.target.value)}
                disabled={isPharmacyModal ? true : (isChatPage ? false : isReadOnly)}
                maxLength={3}
                inputMode="numeric"
                pattern="\d*"
                placeholder="дни"
              />
              <span>дней</span>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ValidityPeriodInput; 